import type { FunctionComponent, ReactElement } from 'react';

import { L12nProps } from '../text';

import styles from './BetLimits.module.css';

export interface BetLimitsProps {
  betLimitData: BetLimitsData;
}

export interface BetLimitsTable {
  name: string | ReactElement<L12nProps>;
  data: Array<Array<string | number | ReactElement<L12nProps>>>; // FIXME: this type check doesn't work
}

export interface BetLimitsData {
  tables: BetLimitsTable[];
  footer: Array<Array<string | number | ReactElement<L12nProps>>>; // FIXME: this type check doesn't work
}

export const BetLimits: FunctionComponent<BetLimitsProps> = ({ betLimitData }) => {
  return (
    <div data-testid="bet-limits" className={styles.betLimits}>
      <table>
        {betLimitData.tables.map((table, i) => (
          <>
            <b>{table.name}</b>
            <tbody>
              {table.data.map((row, j) => (
                <tr key={`tr-${i}-${j}`}>
                  {row.map((data, k) => {
                    if (j === 0) {
                      return <th key={`tr-${i}-${j}-${k}`}>{data}</th>;
                    } else {
                      return <td key={`tr-${i}-${j}-${k}`}>{data}</td>;
                    }
                  })}
                </tr>
              ))}
            </tbody>
          </>
        ))}
      </table>

      {betLimitData && betLimitData.footer && betLimitData.footer.length > 0 && (
        <div className={styles.betLimits__footer}>
          {betLimitData.footer.map((row, i) => (
            <div key={`f-${i}`}>{row.map((el) => el)}</div>
          ))}
        </div>
      )}
    </div>
  );
};
